import { RoleTranslate } from './roleTranslate.model';

const roleTranslateEN: RoleTranslate = {
  administrator: 'Administrator',
  manager: 'Manager',
  member: 'Member',
};

export default roleTranslateEN;
